export default __webpack_public_path__ + "static/time-axis-with-irregular-intervals-59688889e9149009ebecd0e8f9acaad0.png";